import { render, staticRenderFns } from "./platformTender.vue?vue&type=template&id=7e753e37&scoped=true&"
import script from "./platformTender.vue?vue&type=script&lang=js&"
export * from "./platformTender.vue?vue&type=script&lang=js&"
import style0 from "./platformTender.vue?vue&type=style&index=0&lang=less&"
import style1 from "./platformTender.vue?vue&type=style&index=1&id=7e753e37&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e753e37",
  null
  
)

export default component.exports